import { Template } from '@domains/template/model/api/template.type';
import { TemplateKindType } from '@domains/template/model/api/template-kind-type.enum';
import { BuilderTemplate } from '@website-builder/model/template/builder-template.type';

export function toBuilderTemplate<T extends TemplateKindType>(dto: Template): BuilderTemplate<T> {
  return { ...dto, data: JSON.parse(dto.data) } as BuilderTemplate<T>;
}
